// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget--spacer{position:relative;height:125px;color:#787f87;font-weight:bold}.widget--spacer.is-editable{border:2px dashed #787f87;border-radius:2px}.widget--spacer.is-editable:before{content:\"Platzhalter\";position:absolute;left:50%;bottom:0;text-align:center;text-transform:uppercase;transform:rotate(270deg) translateY(-50%);transform-origin:0 0}", ""]);
// Exports
module.exports = exports;
